var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPrevActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6429 20.4531L0.642888 10.4531L10.6429 0.453126L12.5503 2.36056L5.80652 9.10436L22.7817 9.10436L22.7817 11.8019L5.80652 11.8019L12.5503 18.5457L10.6429 20.4531Z",
    fill: "#ff3900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrevActive);
export default __webpack_public_path__ + "static/media/arrow-prev-active.f00da07d30d12b61062b34ca8a07ab6f.svg";
export { ForwardRef as ReactComponent };